<div #self class="ot-table__header">
  <div class="ot-table__bulk-actions">
    <span class="ot-bulk-selected">
      <span i18n>Selected</span>
      <span class="ot-badge" [title]="count">{{count}}</span>
    </span>
    @for (action of supportedActions; track action) {
      <a tabindex="0" [title]="action.name" (click)="bulkMenuActionClicked(action)" (keydown)="bulkMenuActionKeyDown($event, action)" class="bulk-action-item">
        {{action.name}}
      </a>
    }
  </div>
  <div class="ot-table__header-right">
  </div>
</div>